<template>
  <div>
    <v-card class="my-1">
      <v-card-title>My Monthly Attendance</v-card-title>
      <v-row class="px-4">
        <v-col class="py-0">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDateDisplay"
                v-validate="'required'"
                label="Start Date"
                :error-messages="errors.collect('startDateDisplay')"
                data-vv-name="startDateDisplay"  
                data-vv-as="start date"    
                readonly
                outlined
                class="label-position"
                v-on="on"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              :max="endDate || today"
              @input="startDateMenu = false"
            />
          </v-menu>
        </v-col>

        <v-col class="py-0">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDateDisplay"
                v-validate="'required'"
                label="End Date"
                :error-messages="errors.collect('endDateDisplay')"
                data-vv-name="endDateDisplay"  
                data-vv-as="end date"  
                readonly
                outlined
                class="label-position"
                v-on="on"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              :min="startDate"
              :max="today"
              @input="endDateMenu = false"
            />
          </v-menu>
        </v-col>
    
        <v-col>
          <v-row>
            <v-btn
              class="mx-3"
              color="primary"
              :loading="loading"
              @click="download"
            >
              generate
            </v-btn>
          </v-row>
        </v-col>
      </v-row> 
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,
        loading: false,
        today: new Date().toISOString().slice(0, 10), 
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    methods: {
      download () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.myAttendances().download({ startDate: this.startDate, endDate: this.endDate })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                
                const now = new Date()
                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                const hours = String(now.getHours()).padStart(2, '0')
                const minutes = String(now.getMinutes()).padStart(2, '0')
                const seconds = String(now.getSeconds()).padStart(2, '0')

                link.setAttribute('download', 'Attendance_' + year + month + day + hours + minutes + seconds + '.pdf') 
                link.click()
                this.loading = false
              }).catch((e) => {
                this.loading = false
                if (e.response.status === 404) {
                  this.$snack({ color: 'error', message: 'No record found' })
                } else {
                  this.$snack({ color: 'error', message: 'Error! Please contact IT support' })
                }
              })
          })
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
